export const GRAPHQL_LINK = "https://engu-api.herokuapp.com/graphql";
export const PHOTO_LINK = "https://engu-api.herokuapp.com/products/";

// export const GRAPHQL_LINK = "http://localhost:5001/graphql";
// export const PHOTO_LINK = "http://localhost:5001/products/";
